import {
	FETCH_SURVEYS_REQUEST,
	FETCH_SURVEYS_SUCCESS,
	FETCH_SURVEYS_FAIL,
	FETCH_SURVEY_REQUEST,
	FETCH_SURVEY_SUCCESS,
	FETCH_SURVEY_FAIL,
	DOWNLOAD_SURVEYS_REQUEST,
	DOWNLOAD_SURVEYS_SUCCESS,
	DOWNLOAD_SURVEYS_FAIL,
} from "../constants/survey";

function fetchSurveysReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
		};
	}
	switch (action.type) {
		case FETCH_SURVEYS_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SURVEYS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				surveys: action.payload,
			};
		case FETCH_SURVEYS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function fetchSurveyReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
		};
	}

	switch (action.type) {
		case FETCH_SURVEY_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SURVEY_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				survey: action.payload,
			};
		case FETCH_SURVEY_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function downloadSurveysReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
		};
	}

	switch (action.type) {
		case DOWNLOAD_SURVEYS_REQUEST:
			return { loading: true, status: "IDLE" };
		case DOWNLOAD_SURVEYS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				file: action.payload,
			};
		case DOWNLOAD_SURVEYS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

export { fetchSurveysReducer, fetchSurveyReducer, downloadSurveysReducer };
